import { render, staticRenderFns } from "./subirDocumento.vue?vue&type=template&id=49fb9f3c"
import script from "./subirDocumento.vue?vue&type=script&lang=js"
export * from "./subirDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports